import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';

import { useErrorToast } from '@/components/layers/ReactQueryProvider';
import { Api } from '@/core/api';
import { useCurrentUser } from '@/core/hooks/useCurrentUser';

import type { FiltersState } from '@/core/modules/MapPanelSources';

export const QUERY_KEY_INCIDENTS = 'map-incidents';

type QueryParams = {
  enabled?: boolean;
  limit?: number | null;
  filters?: FiltersState;
};

export const useIncidentsData = ({ enabled = true, limit, filters, ...params }: QueryParams) => {
  const { orgId } = useCurrentUser();

  const { data, ...query } = useQuery({
    queryKey: [QUERY_KEY_INCIDENTS, orgId, limit, filters],
    queryFn: ({ queryKey }) => {
      // const [, keyOrgId, keyLimit, keyFilters] = queryKey as [string, string, number | null, FiltersState | null];

      return Api.mapEvents.getIncidents({
        orgId: orgId,
        limit: limit ?? undefined,
        filters: filters ?? undefined,
      });
    },
    placeholderData: [],
    enabled,
  });

  useErrorToast(query);

  return { data, incidentsData: isEmpty(data) ? [] : data!, ...query };
};
